import { render, staticRenderFns } from "./Convenios.vue?vue&type=template&id=bfc60618&scoped=true&"
import script from "./Convenios.vue?vue&type=script&lang=js&"
export * from "./Convenios.vue?vue&type=script&lang=js&"
import style0 from "./Convenios.vue?vue&type=style&index=0&id=bfc60618&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bfc60618",
  null
  
)

export default component.exports